import api from "@/lib/api";

export interface GetLoginSharingCodeRequest {
  pageName: string;
}

export interface GetLoginSharingCodeResponse {
  loginSharingCode: string;
  loginSharingValidSeconds: string;
}

export default {
  getLoginSharingCode(data: GetLoginSharingCodeRequest) {
    return api<GetLoginSharingCodeRequest, GetLoginSharingCodeResponse>({
      endpoint: "login-sharing/web-api/login-sharing-code",
      method: "GET",
      queryParams: data
    });
  }
};
